import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ROUTER_BASENAME } from "@/buildInfo";
import App from "@/App";
import { AuthProvider } from "@/components/AuthProvider";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { XeroProvider } from "@/components/XeroProvider";
import "@/index.css";

const container = document.getElementById("root");
if (!container)
  throw new Error("Root element #root is missing from index.html");

/*
 * The LAST RESORT, and it is a second boundary rather than the only one.
 *
 * The one that matters day to day is inside `AppShell` in `App.tsx`, keyed by
 * route: a page that throws is contained there, the chrome survives, and the
 * person clicks another nav row. This one catches what that one cannot reach --
 * a throw in `AppShell` itself, in `RequireAuth`, or in either provider. Those
 * are rarer and there is no chrome left to offer, so all it can do is say so
 * instead of leaving `#root` empty, which is what happened before it existed.
 *
 * ⚠️ **OUTSIDE the providers on purpose.** A boundary inside `AuthProvider`
 * cannot catch that provider throwing, and the auth and Xero reads are exactly
 * the kind of code that meets a shape it did not expect.
 */
createRoot(container).render(
  <StrictMode>
    <ErrorBoundary scope="the app">
      <BrowserRouter basename={ROUTER_BASENAME}>
        <AuthProvider>
          <XeroProvider>
            <App />
          </XeroProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
